import React from 'react';
import { Grid, Heading } from '@walmart-web/livingdesign-components';
import { useTranslation } from 'react-i18next';
import FaqAccordionItem from './FaqAccordionItem/index.tsx';

type Props = {
  seeAll: boolean;
};

type Data = {
  title: string;
  content: string;
};

const FaqResources: React.FC<Props> = ({ seeAll }) => {
  const { t } = useTranslation('ihut');

  const DATA = t('faq.questions', { returnObjects: true }) as Data[];

  return (
    <Grid>
      <Heading size="small">{t('faq.heading')}</Heading>

      {DATA.slice(0, seeAll ? DATA.length : 5).map(
        ({ title, content }, idx) => (
          <FaqAccordionItem
            key={idx}
            title={title}
            body={content}
            defaultExpanded={idx === 0}
          />
        )
      )}
    </Grid>
  );
};

export default FaqResources;
